<template>
    <p-inc-todo-card
        :item = "item"
    >
        <template v-slot:comment>
            <div class="v-flex">
                <div class="card-subtitle status-line">
                    <span>
                        {{ dateAsString (item.nextAssessment) }}
                    </span>
                    <span class="ml-1 warning--text" v-if="item.dateScheduled">
                        ZÜS Prüfung geplant für {{ dateAsString (item.dateScheduled) }}
                    </span>
                </div>
                <v-spacer/>
                <div class="card-subtitle" :class="textColor()" v-if="item.begin && !future">
                    {{ delay }} Tage
                </div>
            </div>
        </template>
    </p-inc-todo-card></template>

<script>

import Core             from "@/modules/core/service/Core";
import PIncTodoCard     from "@/modules/inc/todos/components/private/PIncTodoCard.vue";
import IncTodoCardMixin from "@/modules/inc/todos/components/mixins/IncTodoCardMixin";

export default {
    name: "PIncAssessmentDelayCard",

    components: {
        PIncTodoCard,
    },

    mixins: [
        IncTodoCardMixin
    ],

    props: {
        item: {

        }
    },

    computed: {
        delay () {
            return Core.format.delayInDays(this.item.nextAssessment);
        },

        future () {
            return Core.format.future(this.item.nextAssessment)
        }
    },

    methods: {
        textColor () {
            if (this.delay >= 14) {
                return "error--text"
            }

            return 'primary--text';
        }
    }
}
</script>

<style scoped>

.card-subtitle {
    font-size: 13px;
}

</style>